import { MATCH_FILTER_KEYS } from "../utils/constant";

export default {
  SET_PREMATCH_COUNT(state, count) {
    state.prematch.count = count;
  },

  SET_PREMATCH_SORT(state, { type, order }) {
    state.prematch.sort = Object.assign({}, { type, order });
  },

  SET_PREMATCH_FILTER(state, filterKey) {
    state.prematch.filters[0] = MATCH_FILTER_KEYS[filterKey];
  },

  TOGLE_PREMATCH_EXPANDED(state, id) {
    const index = state.prematch.expanded.findIndex((row) => row === id);
    if (index >= 0) {
      state.prematch.expanded = state.prematch.expanded.filter(
        (_, i) => i !== index,
      );
    } else {
      state.prematch.expanded = [...state.prematch.expanded, id];
    }
  },

  TOGLE_PREMATCH_SINGLE_FILTER: (state, { filterType, filterValue }) => {
    const filters = state.prematch.filters;
    const index = filters.findIndex((filter) =>
      typeof filter === "string"
        ? filter === filterType
        : filter.type === filterType,
    );

    if (index === -1) {
      throw new Error(`Invalid filter type: ${filterType}`);
    }

    filters[index].value = filterValue;
  },
  SET_PREMATCH_MATCHES: ({ prematch }, matches) => {
    prematch.matches = matches;
  },
};
